import { handlePopState } from '../slices';

/**
 * Middleware to handle browser history events and sync with Redux
 */
const navigationMiddleware = store => {
  // Flag to track if listener is attached
  let isListenerAttached = false;

  // PopState event handler
  const handleBrowserNavigation = () => {
    // Update breadcrumbs based on current URL
    store.dispatch(
      handlePopState({
        search: document.location.search,
        pathname: document.location.pathname,
      })
    );
  };

  return next => action => {
    // Attach listener on first navigation action if not already attached
    if (
      !isListenerAttached &&
      (action.type === 'navigation/navigateToRoute/pending' ||
        action.type === 'navigation/initBreadcrumbsFromUrl')
    ) {
      window.addEventListener('popstate', handleBrowserNavigation, true);
      isListenerAttached = true;

      // Cleanup function for when app unmounts
      if (typeof window !== 'undefined' && window.addEventListener) {
        const originalRemoveEventListener = window.removeEventListener;
        window.removeEventListener = function (...args) {
          if (args[0] === 'popstate' && args[1] === handleBrowserNavigation) {
            isListenerAttached = false;
          }
          return originalRemoveEventListener.apply(this, args);
        };
      }
    }

    // Pass action to next middleware
    return next(action);
  };
};

export default navigationMiddleware;
